export default "__VITE_ASSET__dLq$HuEM__"